/* eslint-disable import/prefer-default-export */
import cloneDeep from 'lodash.clonedeep';
import {
  FormTemplate,
  FormTemplateSection,
} from 'data/template/template.types';
import { CfFtpInfo } from 'data/cfFtpInfo/cfFtpInfo.types';

export type ListenersIpAddressPortsType = {
  [key: string]: string[],
}

export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode: 'create' | 'edit' | 'view' | 'copy',
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'edit') {
    (clonedTemplate.main as FormTemplateSection).fields.FTPID.readOnly = true;
    (clonedTemplate.main as FormTemplateSection).fields.USERPASSWD.readOnly = true;
  } else if (mode === 'view') {
    setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
  } else if (mode === 'create') {
    (clonedTemplate.main as FormTemplateSection).fields.FTPFILESEC.initial = 60;
  }

  return clonedTemplate;
}

function setAllFieldsAsReadOnlyExcludingFields(template: FormTemplate, excludingFields: string[]) {
  Object.entries(template).forEach(([_templateKey, templateEntry]) => {
    if (typeof templateEntry === 'string') {
      return;
    }
    Object.entries(templateEntry.fields).forEach(([fieldKey, fieldEntry]) => {
      if (!excludingFields.includes(fieldKey)) {
        fieldEntry.readOnly = true;
      }
    });
  });
}

export function adaptCfFtpInfoTemplate(
  template: FormTemplate,
): FormTemplate {

  const clonedTemplate = cloneDeep(template);
  clonedTemplate.key = Date.now().toString();
  clonedTemplate.formId = Date.now().toString();

  return clonedTemplate;
}

export function adaptInitialCfFtpInfoFormData(
  cfFtpInfo: CfFtpInfo,
): CfFtpInfo {

  const clonedCfFtpInfo = cloneDeep(cfFtpInfo);
  clonedCfFtpInfo.FTPFILESIZE = '2048'
  clonedCfFtpInfo.FTPFILESEC = '60';
  return clonedCfFtpInfo;
}
